import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { LocationTypesReducer } from "../reducers/LocationTypeReducer";

const LocationTypesContext = createContext({
	state: LocationTypesReducer.getInitialState(),
	actions: LocationTypesReducer.actions,
});
export const useLocationTypesContext = () => useContext(LocationTypesContext);

export const LocationTypeProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: LocationTypesReducer.getInitialState(),
		reducers: LocationTypesReducer.caseReducers,
	});
	return (
		<LocationTypesContext.Provider value={{ state, actions }}>
			{children}
		</LocationTypesContext.Provider>
	);
};
